import { performRESTRequest } from "@ng-mw/framework-core"
import { BareMinimumRecipe } from "@modules/recipes/recipeTypes"

export const fetchRecipe = async (recipeId: string): Promise<BareMinimumRecipe | null> => {
    try {
        const response = await performRESTRequest({
            path: `/api/recipes2/1300/${recipeId}`,
            method: "GET",
            noncritical: true,
        })

        const data = response as any

        return {
            id: data.id,
            name: data.name,
            media: {
                imageId: data.media?.imageId,
            },
            timeEstimate: data.timeEstimate,
        }
    } catch (e: any) {
        if (e?.status === 404) return null

        throw e
    }
}
